<div class="text--center">
  <h1>Your basket is empty.</h1>
  <dgx-components-button (click)="handleViewBasket()" class="mt-8">
    Choose your Sky box
  </dgx-components-button>
</div>
